"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("button", {
    staticClass: "navbar-toggler",
    class: [{
      toggled: _vm.toggled
    }, {
      collapsed: !_vm.toggled
    }],
    attrs: {
      type: "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c("span", {
    staticClass: "navbar-toggler-bar top-bar"
  }), _vm._v(" "), _c("span", {
    staticClass: "navbar-toggler-bar middle-bar"
  }), _vm._v(" "), _c("span", {
    staticClass: "navbar-toggler-bar bottom-bar"
  })]);
};
exports.render = render;
var staticRenderFns = [];
exports.staticRenderFns = staticRenderFns;
render._withStripped = true;